import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

let middleware = null;
    middleware = applyMiddleware(
        thunkMiddleware);
export default function configureStore(initialState = {}) {
    const store = createStore(
        rootReducer,
        initialState,
        middleware
    );

    return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js